import { ProjectPayload, ProjectUpdatePayload } from "Types/Project";
import { get, post, put, remove } from "../../ApiService";
import { ApiUrl, FiltersType, SsoApiUrl } from "../../ApiUrl";

export const createProject = async (data: ProjectPayload) => {
  try {
    const res = await post(`${SsoApiUrl.projectManagement.projects}`, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export interface ProjectsFiltersType extends FiltersType {
  manager?: string; // accountManager refs
  organization?: string; // organization refs
  status?: string; // status codes
  name?: string; 
  email?: string; 
  project_list_type?: string;
  order_by?: string;
}

export const getProjects = async (filters?: ProjectsFiltersType) => {
  try {
    const res = await get(`${SsoApiUrl.projectManagement.projects}`, filters);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getProject = async (ref: string) => {
  try {
    const res = await get(`${SsoApiUrl.projectManagement.project(ref)}`);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateProject = async (
  ref: string,
  data: ProjectUpdatePayload
) => {
  try {
    const res = await put(`${SsoApiUrl.projectManagement.project(ref)}`, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getProjectUsers = async (ref: string, filters?: FiltersType & { order_by?: string; organization_roles?: string }) => {
  const page = filters?.page || 1;
  const pageSize = filters?.pageSize;
  const order_by = filters?.order_by;
  const organization_roles = filters?.organization_roles;
  try {
    const res = await get(`${SsoApiUrl.projectManagement.projectUsers(ref)}`, {
      page,
      pageSize,
      ...(order_by && { order_by }),
      ...(organization_roles && { organization_roles }),
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const removeProjectUser = async (ref: string, useRef: string) => {
  try {
    const res = await remove(
      `${SsoApiUrl.projectManagement.projectUser(ref, useRef)}`
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const assignProjectUserRole = async (
  ref: string,
  useRef: string,
  roleId: number
) => {
  try {
    const res = await put(
      `${SsoApiUrl.projectManagement.projectUserRole(ref, useRef, roleId)}`,
      {}
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};
